/* eslint-disable max-lines */

import React from 'react';
import { CohortAuditLog } from 'types';
import NestedListItem from './NestedListItem';

type ComponentProps = {
  items: CohortAuditLog[];
};

const AuditLogNestedList: React.FC<ComponentProps> = ({ items }) => (
  <tr className="row-hover table-row border-t border-gray-200 align-middle hover:bg-litlingo-gray-0">
    <td colSpan={7} className="table-wrapper__new-td pl-0">
      <table className="w-full h-full">
        <thead className="w-full">
          <tr className="w-full h-9 bg-litlingo-gray-0.5">
            <th className="text-left text-body table-wrapper__th--w-16 pl-9">Change</th>
            <th className="text-left text-body table-wrapper__th--w-14">Type</th>
            <th className="text-left text-body table-wrapper__th--w-16">Name</th>
            <th className="text-left text-body">Email</th>
          </tr>
        </thead>
        <tbody className="table-wrapper__tbody">
          {items.map((item) => (
            <NestedListItem key={item.payload.user_uuid} item={item} />
          ))}
        </tbody>
      </table>
    </td>
  </tr>
);

export default AuditLogNestedList;
